import { Modal, Button, Input, notification, Form, Space, Switch } from 'antd';
import React, { useState } from 'react';
import { useAppDispatch, useAuth } from '../../store/hooks';
import { addCompany } from '../../store/companySlice';

interface AddCompanyModalProps {
    open: boolean;
    handleClose: () => void;
}

const AddCompanyModal: React.FC<AddCompanyModalProps> = ({ open, handleClose }) => {

    const auth = useAuth()
    const dispatch = useAppDispatch()
    type CreateCompanyFormValues = {
        name: string;
        modules?: {
            shopify?: boolean;
            customContent?: boolean;
            generation?: boolean;
            brandResearch?: boolean;
        };
    };
    const [createCompanyForm] = Form.useForm<CreateCompanyFormValues>()
    const [loading, setLoading] = useState<boolean>(false)


    const onFinishCreateCompanyForm = async (values: CreateCompanyFormValues) => {
        setLoading(true)
        try {
            if (!auth.currentUser) throw new Error("No auth for creating Company");

            await dispatch(addCompany({
                ...values,
                modules: {
                    shopify: Boolean(values.modules?.shopify),
                    customContent: Boolean(values.modules?.customContent),
                    generation: Boolean(values.modules?.generation),
                    brandResearch: Boolean(values.modules?.brandResearch),
                },
                generationQuota: {
                    shopify: { max: null },
                    customContent: { max: null },
                    brandResearch: { max: null },
                    brandKeywordAssignment: { max: null },
                },
                generationUsage: {
                    shopify: 0,
                    customContent: 0,
                    brandResearch: 0,
                    brandKeywordAssignment: 0,
                },
                accessLevels: {
                    [auth?.currentUser?.uid]: 80,
                },
                createdBy: auth?.currentUser?.uid,
                updatedBy: auth?.currentUser?.uid,
            }))

            notification.success({
                message: 'Company Created',
                description: 'The  Company has been created successfully.',
                duration: 3
            })
            createCompanyForm.resetFields()
            handleClose()
        } catch (error) {
            console.error("Error creating the company", error)
            notification.error({
                message: 'Error Creating Company',
                description: 'There was an error creating the company. If the error persists, please contact support.',
                duration: 3,
            });
        } finally {
            setLoading(false)

        }
    }


    return (
        <Modal
            open={open}
            title={"Add Company"}
            width={"70vw"}
            onCancel={handleClose}
            footer={[
                <Button key="cancel" onClick={handleClose}>
                    Cancel
                </Button>,
                <Button
                    key="save"
                    type="primary"
                    onClick={() => createCompanyForm.submit()}
                    loading={loading}
                    disabled={loading}
                >
                    Add
                </Button>,
            ]}
        >
            <Form layout="vertical" onFinish={onFinishCreateCompanyForm} form={createCompanyForm}>
                <Form.Item
                    label="Company Name"
                    name="name"
                    rules={[
                        { required: true, message: 'Please input a Name for the company!' },
                    ]}
                >
                    <Input autoFocus />
                </Form.Item>
                <Form.Item label="Modules">
                    <Space size="large" wrap>
                        <Form.Item name={['modules', 'shopify']} valuePropName="checked" noStyle>
                            <Switch checkedChildren="Shopify" unCheckedChildren="Shopify" />
                        </Form.Item>
                        <Form.Item name={['modules', 'customContent']} valuePropName="checked" noStyle>
                            <Switch checkedChildren="Custom Content" unCheckedChildren="Custom Content" />
                        </Form.Item>
                        <Form.Item name={['modules', 'generation']} valuePropName="checked" noStyle>
                            <Switch checkedChildren="Generation" unCheckedChildren="Generation" />
                        </Form.Item>
                        <Form.Item name={['modules', 'brandResearch']} valuePropName="checked" noStyle>
                            <Switch checkedChildren="Brand Research" unCheckedChildren="Brand Research" />
                        </Form.Item>
                    </Space>
                </Form.Item>
            </Form>

        </Modal >
    );
};

export default AddCompanyModal;
